const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20Chinese%20man%20with%20friendly%20smile%2C%20casual%20style%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20natural%20look&width=120&height=120&seq=avatar-01&orientation=squarish',
    name: '影迷小张',
    time: '2小时前',
    content: '用了宅男视频半年了，真的比其他平台流畅太多！久久视频和豆花视频的片源更新也快，想看的新剧基本当天就有了。画质清晰，关键是真的不卡，太赞了！',
    rating: 5,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Casual%20portrait%20of%20a%20young%20Chinese%20woman%20with%20warm%20smile%2C%20natural%20look%2C%20clean%20light%20background%2C%20soft%20studio%20lighting%2C%20relaxed%20atmosphere&width=120&height=120&seq=avatar-02&orientation=squarish',
    name: '追剧达人',
    time: '5小时前',
    content: '小蓝视频的内容质量真的高，配合宅男视频的极速引擎，晚上高峰期看也不缓冲。已经推荐给身边所有追剧的朋友了，都说好用！每天下班回家第一件事就是打开宅男视频。',
    rating: 5,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Natural%20portrait%20of%20a%20Chinese%20man%20in%20his%20late%2020s%2C%20friendly%20expression%2C%20casual%20shirt%2C%20clean%20white%20background%2C%20soft%20professional%20lighting%2C%20warm%20tone&width=120&height=120&seq=avatar-03&orientation=squarish',
    name: '电影爱好者',
    time: '1天前',
    content: '作为一个重度电影迷，宅男视频的片库真的太全了。久久视频的高清专区画质炸裂，豆花视频的免费全集也很良心。最重要的是播放稳定，再也没有看到一半卡住的烦恼了。',
    rating: 5,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">用户口碑</h2>
            <p className="text-sm md:text-base text-foreground-600">真实用户反馈，听他们怎么说宅男视频的流畅体验</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {comments.map((c, i) => (
              <div key={i} className="bg-background-100 rounded-xl p-5 border border-background-200/70">
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: c.rating }).map((_, j) => (
                    <i key={j} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">{c.content}</p>
                <div className="flex items-center gap-3 border-t border-background-200/70 pt-4">
                  <img
                    src={c.avatar}
                    alt={c.name}
                    className="w-9 h-9 rounded-full object-cover"
                    onError={(e) => { (e.target as HTMLElement).style.display = 'none'; }}
                  />
                  <div>
                    <div className="text-sm font-semibold text-foreground-900">{c.name}</div>
                    <div className="text-xs text-foreground-600">{c.time}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}